module.exports = __webpack_public_path__ + "img/9ddda90.svg";